export class EmailFaxRequest {
  reportID: string;
  email: string;
  accessionId: string;
  faxNumber: string;
  bu: string;
  reportSent: boolean;
}
